import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68d189bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "logo" }, "Siternet", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "links-container" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "link-name" }

import Link from '@/types/Link.type';
import { PropType, onMounted } from 'vue';
import { onClickOutside } from '@vueuse/core';
import { ref } from 'vue';

//* Defined.

export default /*#__PURE__*/_defineComponent({
  __name: 'NavDrawer',
  props: {
  links: { type: Array as PropType<Link[]>, required: true, },
  show: { type: Boolean, required: true },
},
  emits: ['closeDrawer'],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const props = __props;
const drawer = ref<HTMLElement>();

//* Functions.
onClickOutside(drawer, () => {
  emit('closeDrawer');
});

const closeAfterClick = () => {
  emit('closeDrawer');
}

return (_ctx: any,_cache: any) => {
  const _component_fai = _resolveComponent("fai")!

  return (_openBlock(), _createBlock(_Transition, null, {
    default: _withCtx(() => [
      (__props.show)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "drawer",
            ref_key: "drawer",
            ref: drawer
          }, [
            _hoisted_1,
            _hoisted_2,
            _createElementVNode("ul", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.links, (l, idx) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: _normalizeClass(["link-container", { accent: l.accent }]),
                  key: idx
                }, [
                  _createElementVNode("a", {
                    href: l.url,
                    onClick: closeAfterClick
                  }, [
                    _createVNode(_component_fai, {
                      class: "icon",
                      icon: 'fa-solid ' + l.icon
                    }, null, 8, ["icon"]),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(l.name), 1)
                  ], 8, _hoisted_4)
                ], 2))
              }), 128))
            ])
          ], 512))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})